import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { BaseRef } from "@shared/models/BaseRef";
import { ButtonModule } from "primeng/button";
import { DialogModule } from "primeng/dialog";
import { DropdownModule } from "primeng/dropdown";

@Component({
  selector: "app-document-info-popup",
  standalone: true,
  imports: [CommonModule, FormsModule, DropdownModule, DialogModule, ButtonModule, TranslateModule],
  templateUrl: "./document-info-popup.component.html",
  styleUrls: ["./document-info-popup.component.scss"],
})
export class DocumentInfoPopupComponent implements OnChanges {
  @Input() fileName?: string = "";
  @Input() visible!: boolean;
  @Input() documentTypes: BaseRef[] = [];
  selectedType!: string;

  @Output() close = new EventEmitter<void>();
  @Output() save = new EventEmitter<string>();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["documentTypes"] && this.documentTypes.length === 1) {
      this.selectedType = this.documentTypes[0].code;
    }
  }

  onSave() {
    if (this.selectedType) {
      this.save.emit(this.selectedType);
    }
  }

  onClose() {
    this.close.emit();
  }
}
